import React from 'react';
import { Scale, MessageSquare, BookOpen, ArrowRight } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Scale,
      title: 'Compare Side by Side',
      description:
        'Compare features, pricing, and reviews of multiple tools to find the perfect match for your needs.',
      color: 'from-blue-500 to-indigo-500',
      bgColor: 'bg-blue-50',
    },
    {
      icon: MessageSquare,
      title: 'Real User Reviews',
      description:
        'Read authentic reviews from verified users who have hands-on experience with the tools.',
      color: 'from-amber-500 to-orange-500',
      bgColor: 'bg-amber-50',
    },
    {
      icon: BookOpen,
      title: 'In-Depth Guides',
      description:
        'Access detailed buying guides and expert recommendations to make informed decisions.',
      color: 'from-purple-500 to-violet-500',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Why Choose ToolsMetric?
          </h2>
          <p className="text-lg text-gray-600">
            We make it easy to discover, compare, and choose the right software for your business
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={feature.title}
                className="group bg-white rounded-2xl p-8 border border-gray-100 hover:border-gray-200 hover:shadow-xl hover:shadow-gray-100/50 transition-all duration-300"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Icon */}
                <div
                  className={`w-14 h-14 rounded-xl ${feature.bgColor} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
                >
                  <IconComponent
                    className={`w-7 h-7 bg-gradient-to-r ${feature.color} bg-clip-text`}
                    style={{
                      color:
                        feature.color === 'from-blue-500 to-indigo-500'
                          ? '#3b82f6'
                          : feature.color === 'from-amber-500 to-orange-500'
                          ? '#f59e0b'
                          : '#8b5cf6',
                    }}
                  />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {feature.description}
                </p>

                {/* Link */}
                <button className="inline-flex items-center gap-2 text-sm font-medium text-emerald-600 hover:text-emerald-700 group/link">
                  Learn more
                  <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;